/**
 * Maps the backend `chatChannel` enum (lowercase) onto the Title Case
 * `chat_experience_name` value emitted on PostHog events.
 *
 * Per the AI-768 spec, `chat_experience_name` is conversation-driven (distinct
 * from `context`, which is surface-driven). A null/absent channel means the
 * conversation is running the default AI Chat experience.
 *
 * Backend values are intentionally narrow today (`tarot`, `oracle_cards`,
 * `horoscope`) — pass-through for unknown values keeps us honest if a new
 * backend channel rolls out before this map is updated; analytics will surface
 * the raw value instead of silently coalescing to `Default`.
 */
const KNOWN_CHANNEL_TO_EXPERIENCE_NAME: Record<string, string> = {
  tarot: 'Tarot',
  oracle_cards: 'Oracle Cards',
  horoscope: 'Horoscope',
}

export const DEFAULT_CHAT_EXPERIENCE_NAME = 'Default'

export const getChatExperienceName = (
  chatChannel: string | null | undefined,
): string => {
  if (!chatChannel) return DEFAULT_CHAT_EXPERIENCE_NAME
  return KNOWN_CHANNEL_TO_EXPERIENCE_NAME[chatChannel] ?? chatChannel
}
